
export const scrollToValuation = () => {
  const valuationSection = document.getElementById('valuation-section');
  if (valuationSection) {
    valuationSection.scrollIntoView({ behavior: 'smooth' });
    setTimeout(() => {
      const regInput = document.getElementById('registration-input');
      if (regInput) {
        regInput.focus();
      }
    }, 500);
  }
};
